<template>
  <component
    :is="goesTo ? 'inertia-link' : 'button'"
    :href="goesTo"
    ref="jet-button"
    :type="goesTo ? '' : type"
    :disabled="disable"
    :loading="loading"
    :class="[`btn-${btnStyle}`, {'btn-disabled':disable}]"
    class="btn btn-ripple position-relative" 
    preserve-scroll>
      <i v-if="icon && icon.length" :class="[icon, {'mr-2': $slots.default}]"></i>
      <div v-if="disable || loading" class="btn-spinner flex-center" style="background: rgba(100, 100, 100, 0.7);">
        <i class="fas fa-spinner fa-spin" style="font-size: 2rem;"></i>
      </div>
      <slot></slot>
  </component>
</template>

<script>
  /*
    Renders an <inertia-link> if the :goesTo prop has a route value. Otherwise, render a <button> tag. This is done for semantic purposes
  */

  export default {
    props: {
      type: {
        type: String,
        default: 'button',
      },
      btnStyle: {
        type: String,
        default: 'primary'
      },
      icon: {
        type: String,
        default: ''
      },
      disable: Boolean,
      loading: Boolean,
      goesTo: [Function, String]
    },
  }
</script>
